// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui.dimmer[data-v-a1d64aaa] {\n    background-color: rgba(0,0,0,.1) !important;\n}\n", ""]);
// Exports
module.exports = exports;
